
import '../css/index.css';         // Global styles
import '../css/components.css';    // Component styles
import '../css/safra.css';         // Safra Module styles

// 1. Initial Config
import { supabase } from './services/supabase-config.ts';
import './utils/formatters.ts';

// 2. Global Components (Legacy scripts that attach to window)
import './components/header.js';
import './components/toast.js';
import './components/nav.js';
import './config-logo.js';

// 3. Page Modules (These likely attach to window.FazendaRP.Pages or similar)
import './pages/financeiro/core.js';
import './pages/financeiro/agenda.js';
import './pages/financeiro/dashboard_fin.js';
import './pages/financeiro/modules/lancamentos-magic.js';
import './pages/financeiro/modules/lancamentos-lista.js';
import './pages/financeiro/inbox.js';
import './pages/financeiro/modules/lancamentos-form.js';
import './pages/financeiro/modules/lancamentos-crud.js';
import './pages/financeiro/modules/certificados.js';
import './pages/financeiro/movimentacoes.js';
import './pages/financeiro/galeria.js';
import './pages/financeiro/contas.js';
import './pages/financeiro/cartao.js';
import './pages/financeiro/fluxo-caixa.js';
import './pages/financeiro/ir.js';
import './pages/financeiro/plano-contas.js';
import './pages/sistema.js';
import './pages/sistema_variedades.js';
import './pages/financeiro/conciliacao.js';

import './pages/suprimentos/core.js';
import './pages/suprimentos/dashboard.js';
import './pages/suprimentos/historico.js';

// Estoque Modular
import './pages/suprimentos/estoque/calculator.js';
import './pages/suprimentos/estoque/data-service.js';
import './pages/suprimentos/estoque/reconciliation.js';
import './pages/suprimentos/estoque/movements-api.js';
import './pages/suprimentos/estoque/index.js';
import './pages/suprimentos/estoque/timeline-modal.js';
import './pages/suprimentos/estoque/adjustment-modal.js';

import './pages/maquinas_new.js';
import './pages/clima.js';
import './pages/dashboard.js';

import './pages/safra/core.js';
import './pages/safra/config.js';
import './pages/safra/dashboard.js';
import './pages/safra/contratos.js';
import './pages/safra/colheita.js';

import './pages/relatorios/core.js';
import './pages/relatorios/balanco.js';
import './pages/relatorios/bi_explorer.js';

import './pages/operacional/shared.js';
import './pages/operacional/dashboard.js';
import './pages/operacional/prescricoes.js';
import './pages/operacional/diario.js';
import './pages/operacional/calendario.js';
import './pages/operacional/notifications.js';
import './pages/operacional/exports.js';
import './pages/operacional/core.js';

import './pages/auditoria/auditoria.js';
import './pages/whatsapp.js';

// 4. Router needs to run last or be imported
import './router.js';

// Main Application Logic (Ported from js/main.js)
document.addEventListener('DOMContentLoaded', async () => {
    try {
        // Auth Guard
        const { data: { session }, error } = await supabase.auth.getSession();

        if (error) {
            throw new Error(`Erro de Conexão com Supabase: ${error.message}`);
        }

        if (!session) {
            // Se não estiver logado, redireciona para login
            // if (!window.location.pathname.includes('login.html')) {
            //     window.location.href = 'login.html';
            // }
            // return;
            console.warn("⚠️ DEV MODE: Auth Guard Bypassed. Algumas funções podem falhar sem login.");
        }

        // Sincronizar usuário logado (Legacy compatibility logic)
        if (window.FazendaRP?.Pages?.sistema && session) {
            const emailLogado = session.user.email;
            if (emailLogado) {
                // Warning: getUsuariosData might not be ready if system is not init
                // We leave this legacy sync logic for later refactor or let system.js handle it
                console.log(`✅ Logged in as: ${emailLogado}`);
            }
        }

        // Initial Render
        const headerContainer = document.getElementById('main-header');
        if (window.FazendaRP.renderHeader) {
            window.FazendaRP.renderHeader(headerContainer);
        }

        const navContainer = document.getElementById('main-nav');
        if (window.FazendaRP.renderNav) {
            window.FazendaRP.renderNav(navContainer);
        }

    } catch (error: any) {
        console.error("Critical Error:", error);
        const container = document.getElementById('main-content') || document.body;
        container.innerHTML = `
            <div style="color: #333; padding: 50px; text-align: center; font-family: sans-serif;">
                <div style="color: #dc2626; margin-bottom: 20px;">
                    <i class="fas fa-wifi fa-4x"></i>
                </div>
                <h2 style="margin-bottom: 10px;">Problema de Conexão</h2>
                <p style="font-size: 1.1rem; color: #555;">${error.message || 'Erro desconhecido'}</p>
                <div style="margin-top: 30px;">
                    <button onclick="location.reload()" style="background: #2563eb; color: white; border: none; padding: 12px 25px; border-radius: 6px; font-size: 1rem; cursor: pointer;">
                        <i class="fas fa-sync"></i> Tentar Novamente
                    </button>
                </div>
            </div>
        `;
    }
});
